<template>
  <div :class="$style.header">
    <div :class="$style.left">
      <div :class="$style.score">
        {{ score }}
        <div>
          Твой счет
        </div>
      </div>
      <div :class="$style.images" v-if="items">
        <div
          v-for="(item, index) in items"
          :class="classes($style.imageWrapper, item.found && $style.found)"
          :key="index"
        >
          <img
            v-if="item.found"
            :src="item.imageFound"
          >
        </div>
      </div>
    </div>
    <div :class="$style.right">
      <slot />
    </div>
  </div>
</template>
<script>
import classes from '@/utils/classes'

export default {
  name: 'HeaderWithCounter',
  props: {
    items: {
      type: Array,
    },
    score: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.classes = classes
  },
}
</script>
<style lang="scss" module>
@import './HeaderWithCounter.scss';
</style>
